(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.logo = this.querySelector('.header__heading-link');
      this.sections = document.querySelector('#MainContent').querySelectorAll('.shopify-section');
      this.logo_gradient = this.logo.querySelector('#logo__gradient');
      this.logo_gradient_stops = this.logo_gradient.querySelectorAll('stop');
      window.addEventListener('scroll', this.updateLogoColor.bind(this));
      document.addEventListener('DOMContentLoaded', () => {
        this.updateLogoColor();        
      });

    }

    updateLogoColor() {
      let changed = false;
      var logo_start = this.logo.getBoundingClientRect().top + window.scrollY;
      var logo_end = logo_start + this.logo.offsetHeight;
      var top_section = "";
      var bottom_section = "";

      // logo_start  > section_start && section_end > logo_end = whole
      this.sections.forEach((section, index) => {
        if (changed) return
        var section_start = section.getBoundingClientRect().top + window.scrollY;
        var section_end = section_start + section.offsetHeight;
        if (logo_end >= section_start && logo_start <= section_end) {
          if (section_end >= logo_end) {
            var color = this.logo.dataset.logoPrimary;
            if (section.querySelector('.section-color--white') != undefined || section.classList.contains('.section-color--white')) {
              color = this.logo.dataset.logoSecondary;
            }
            this.logo_gradient_stops.forEach((stop) => {
              stop.setAttribute('stop-color', color);
            })
            this.logo_gradient_stops[1].setAttribute('offset', "50%");
            this.logo_gradient_stops[2].setAttribute('offset', "50%");
            changed = true;
          } else {
            // intersection
            if (this.sections[index + 1] != undefined) {
              var next_section_start = this.sections[index + 1].getBoundingClientRect().top + window.scrollY;
              var next_section_end = next_section_start + this.sections[index + 1].offsetHeight;
              if (next_section_end >= logo_end) {
                var next_perc = (((logo_end - next_section_start) / this.logo.offsetHeight) * 100).toFixed(0);
                next_perc = (100 - next_perc) + "%";
                console.log(next_perc)
                var color = this.logo.dataset.logoPrimary;
                var next_color = this.logo.dataset.logoPrimary;
                if (section.querySelector('.section-color--white') != undefined || section.classList.contains('.section-color--white')) {
                  color = this.logo.dataset.logoSecondary;
                }
                if (this.sections[index + 1].querySelector('.section-color--white') != undefined || this.sections[index + 1].classList.contains('.section-color--white')) {
                  next_color = this.logo.dataset.logoSecondary;
                }
                this.logo_gradient_stops[1].setAttribute('offset', next_perc);
                this.logo_gradient_stops[2].setAttribute('offset', next_perc);
                this.logo_gradient_stops[0].setAttribute('stop-color', color);
                this.logo_gradient_stops[1].setAttribute('stop-color', color);
                this.logo_gradient_stops[2].setAttribute('stop-color', next_color);
                this.logo_gradient_stops[3].setAttribute('stop-color', next_color);
                changed = true;
              }
            }
          }
          
        }
      })
      
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
